const initialValue = 30000;

export const insuredValues = Array.from(new Array(95),(val, index) => initialValue + 5000 * index);

export default {
  insuredValues,
};
